import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { account } from "../appWrite";
import Navbar from "../components/Navbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const secret = searchParams.get("secret");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleReset = async () => {
    try {
      if (!userId || !secret) {
        throw new Error("Invalid reset link");
      }
      await account.updateRecovery(userId, secret, newPassword);
      setMessage("Password reset successful! You can now log in.");
    } catch (error) {
      setMessage("Failed to reset password.");
    }
  };

  return (
    <>
      <Navbar current="password" />
      <div className="flex min-h-screen items-center justify-center p-6 bg-gray-100">
        <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-md">
          <h2 className="text-xl font-semibold text-center mb-4">
            Enter New Password
          </h2>
          <div className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
            />
            <button
              type="button"
              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
            </button>
          </div>
          <button
            className="w-full py-1 md:py-2 px-3 mt-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            onClick={handleReset}
          >
            Send Reset Link
          </button>
          {message && (
            <p className="text-center text-sm text-gray-600 mt-2">{message}</p>
          )}
        </div>
      </div>
    </>
  );
}
